var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkDocumentImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9463 8.25V9.75H11.25V40.25H35.25V35.4238H36.75V41C36.75 41.4142 36.4142 41.75 36 41.75H10.5C10.0858 41.75 9.75 41.4142 9.75 41V9C9.75 8.58579 10.0858 8.25 10.5 8.25H15.9463Z",
    fill: "#F37320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5537 13.25V14.75H5.75V45.25H30.25V40.4238H31.75V46C31.75 46.4142 31.4142 46.75 31 46.75H5C4.58579 46.75 4.25 46.4142 4.25 46V14C4.25 13.5858 4.58579 13.25 5 13.25H10.5537Z",
    fill: "#F37320"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7332 17.1992C39.1473 17.1993 39.4832 17.535 39.4832 17.9492C39.4832 18.3634 39.1473 18.6992 38.7332 18.6992H26.4226C26.0084 18.6992 25.6726 18.3634 25.6726 17.9492C25.6726 17.535 26.0084 17.1992 26.4226 17.1992H38.7332Z",
    fill: "#F37320"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7332 23.3535C39.1473 23.3536 39.4832 23.6893 39.4832 24.1035C39.4832 24.5177 39.1473 24.8535 38.7332 24.8535H26.4226C26.0084 24.8535 25.6726 24.5177 25.6726 24.1035C25.6726 23.6893 26.0084 23.3535 26.4226 23.3535H38.7332Z",
    fill: "#F37320"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7332 29.6328C39.1473 29.6329 39.4832 29.9686 39.4832 30.3828C39.4832 30.797 39.1473 31.1328 38.7332 31.1328H26.4226C26.0084 31.1328 25.6726 30.797 25.6726 30.3828C25.6726 29.9686 26.0084 29.6328 26.4226 29.6328H38.7332Z",
    fill: "#F37320"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0809 2.25L33.2225 2.26367C33.3617 2.29039 33.4911 2.35652 33.5956 2.45508L42.5145 10.8711C42.6647 11.0128 42.7499 11.2105 42.7499 11.417V36.0371C42.7499 36.4513 42.4141 36.7871 41.9999 36.7871H15.746C15.3318 36.7871 14.996 36.4513 14.996 36.0371V3L15.0106 2.85254C15.0395 2.70855 15.1103 2.5751 15.2157 2.46973C15.3564 2.32908 15.5471 2.25 15.746 2.25H33.0809ZM16.496 35.2871H41.2499V11.7393L32.7821 3.75H16.496V35.2871Z",
    fill: "#F37320"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8932 3V10.792H41.9996V12.292H33.1432C32.729 12.292 32.3932 11.9562 32.3932 11.542V3H33.8932Z",
    fill: "#F37320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkDocumentImg);
export default __webpack_public_path__ + "static/media/darkDocumentImg.292e018300e91e70ce305c16a8756d97.svg";
export { ForwardRef as ReactComponent };